// Supabase client setup for admin dashboard
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// If env vars are missing (for example on the public site build), avoid throwing.
// Export a safe supabase object: either a real SupabaseClient, or a noop stub
function makeNoopClient() {
	const noop = (result: any) => Promise.resolve({ data: result, error: null });
	
	// Create a chainable query builder stub that supports the full Supabase API
	const createQueryBuilder = () => {
		const builder = {
			select: () => builder,
			insert: () => builder,
			update: () => builder,
			delete: () => builder,
			eq: () => builder,
			neq: () => builder,
			gt: () => builder,
			gte: () => builder,
			lt: () => builder,
			lte: () => builder,
			like: () => builder,
			ilike: () => builder,
			is: () => builder,
			in: () => builder,
			contains: () => builder,
			order: () => builder,
			limit: () => builder,
			range: () => builder,
			single: () => noop(null),
			maybeSingle: () => noop(null),
			then: (resolve: any) => resolve({ data: [], error: null })
		};
		return builder;
	};
	
	const from = () => createQueryBuilder();
	const storage = {
		from: () => ({ upload: () => noop(null), getPublicUrl: () => ({ data: { publicUrl: '' } }), createSignedUrl: () => noop({ signedUrl: '' }), listBuckets: () => noop([]) })
	};
	const auth = {
		getSession: async () => ({ data: { session: null }, error: null }),
		getUser: async () => ({ data: { user: null }, error: null }),
		onAuthStateChange: (cb?: any) => {
			// return an unsubscribe-like object
			if (typeof cb === 'function') cb(null, { event: 'SIGNED_OUT' });
			return { data: null };
		},
		// Supabase v2 auth methods
		signInWithPassword: async ({ email, password }: { email?: string; password?: string }) => ({ data: null, error: new Error('Supabase not configured') }),
		signUp: async ({ email, password }: { email?: string; password?: string }) => ({ data: null, error: new Error('Supabase not configured') }),
		signOut: async () => ({ error: null, data: null }),
		resetPasswordForEmail: async (email: string) => ({ data: null, error: new Error('Supabase not configured') }),
	};
	return { from, storage, auth } as unknown as SupabaseClient;
}

export const supabase: SupabaseClient = isSupabaseConfigured
	? createClient(supabaseUrl!, supabaseAnonKey!)
	: makeNoopClient();
